import { TypeChecker } from '@attain-apps/type-guards'

/**
 * Whether a statement grants or refuses. Explicit deny wins over any allow;
 * with no matching allow the default is deny.
 */
export type Effect = (typeof Effect.ALL)[number]
export namespace Effect {
  export const ALL = ['allow', 'deny'] as const
  export const isEffect = TypeChecker.Factory.oneOf(ALL)
}
